import tokenManager from "@/shared/securityTokenManager.js";

export default class TokenUseCase {
  private readonly _tokenManager = tokenManager;

  async canChangeSchoolFinancialDetails() {
    const schoolBankAccountEditExpiryDT = await tokenManager.getSchoolBankAccountEditExpiryDTAsync();

    const unixTimeInMilliseconds = Math.floor((new Date()).getTime() / 1000);

    return (schoolBankAccountEditExpiryDT >= unixTimeInMilliseconds);
  }

  async getAccessToken() {
    try {
      return await tokenManager.getAccessTokenAsync();
    } catch (error) {
      throw error;
    }
  }

  async setAccessToken(accessToken: string) {
    try {
      await tokenManager.setAccessTokenAsync(accessToken);
    } catch (error) {
      throw error;
    }
  }

  async clearAccessToken() {
    try {
      await tokenManager.setAccessTokenAsync("");
    } catch (error) {
      throw error;
    }
  }

  async doesAccessTokenExist() {
    try {
      return await tokenManager.doesAccessTokenExistAsync();
    } catch (error) {
      throw error;
    }
  }

  async getUserPermissionsAsync() {
    try {
      const result = await tokenManager.getUserPermissionsAsync();
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getSchoolBankAccountEditExpiryDT() {
    try {
      const result = await tokenManager.getSchoolBankAccountEditExpiryDTAsync();
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getTokenExpiryTime() {
    try {
      const timeInSeconds = await tokenManager.getTokenExpiryTime();

      if (timeInSeconds) {
        return Number(timeInSeconds);
      }
    } catch (error) {
      throw error;
    }
  }
}
